module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAVUlEQVQ4T2NgGBxgqvN/YnDNTrf/v+95gfGbJtP/JBmArvmOijzxBmDTTLQBuDQTZQA+zQQNIKQZrwHEaMZpALGasRpAimYMA0jVjGIAOZpRDBjaAAD8AFbTH1sdjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CG.png
// module id = 1107
// module chunks = 0